import React from 'react';
import PropTypes from 'prop-types';
import FlexContainer from '../../../FlexContainer/FlexContainer';
import Gift01Icon from '../../../Icons/Gift01Icon';
import Text from '../../../Text/Text';
import Tooltip from '../../../Tooltip/Tooltip';
import {colors} from '../../../../utils/colors.js';
import css from '../../ReservationProfile.module.scss';

const BundleMarkerCell = ({caption, children}) => (
  <FlexContainer className={css.bundleMarkerCell} flexDirection="column" flexFlow="column" gap={2} alignItems="center" justifyContent="center" width="100%">
    <FlexContainer className={css.bundleMarkerRow} gap={6} alignItems="center" justifyContent="center" width="100%">
      <Gift01Icon color={colors.preArrival} style={{flexShrink: 0, width: 15, height: 15, cursor: 'default'}}/>
      <Tooltip content={children} position="top" portal maxWidth={240} style={{minWidth: 0, display: 'block'}}>
        <Text truncate>{children}</Text>
      </Tooltip>
    </FlexContainer>
    <Text size="xs" color="muted">{caption}</Text>
  </FlexContainer>
);

BundleMarkerCell.propTypes = {
  caption: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
};

export default BundleMarkerCell;
